import { reactive } from 'vue'
import actions from '@/store/toast/actions'
import state from '@/store/toast/state'
import getters from '@/store/toast/getters'

export const toastModule = {
    state: reactive(state),
    actions,
    getters,
}
